<div class="chat-bubble-container" 
     [style.right.px]="bubbleX"
     [style.bottom.px]="bubbleY"
     [class.dragging]="isDragging">
  
  <!-- Ventana de Chat -->
  <div class="chat-window" [@chatWindow]="isChatOpen ? 'open' : 'closed'" *ngIf="isChatOpen || isMinimized">
    <div class="chat-header">
      <div class="header-left">
        <div class="status-indicator" [class.online]="isConnected" [class.offline]="!isConnected"></div>
        <span class="chat-title">ClaudIA Asesores</span>
        <span class="connection-status" *ngIf="!isConnected">(Desconectado)</span>
      </div>
      <div class="header-actions">
        <button class="close-btn" (click)="closeChat()" title="Cerrar">
          <svg width="12" height="12" viewBox="0 0 12 12">
            <path d="M11 1L1 11M1 1l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="chat-body" *ngIf="!isMinimized">
      <!-- Contenedor de mensajes -->
      <div class="messages-container" #messagesContainer>
        <!-- Mensajes del chat -->
        <div 
          *ngFor="let message of messages; trackBy: trackByMessageId" 
          class="message-wrapper"
          [@messageSlide]
          [class.user-message]="isUserMessage(message)"
          [class.agent-message]="!isUserMessage(message) && !isSystemMessage(message)"
          [class.system-message]="isSystemMessage(message)">
          
          <!-- Avatar para mensajes del agente -->
          <div class="message-avatar ai-avatar" *ngIf="!isUserMessage(message) && !isSystemMessage(message)">
            <img 
              src="assets/img/logo/logo_ia.png" 
              alt="ClaudIA Assistant"
              (error)="onImageError($event)"
              loading="lazy" />
          </div>

          <!-- Contenido del mensaje -->
          <div class="message-content" [class.system-content]="isSystemMessage(message)">
            <div 
              class="message-text" 
              [innerHTML]="parseLinksInText(message.content)">
            </div>
            <div class="message-meta" *ngIf="!isSystemMessage(message)">
              <span class="message-time">{{ formatTime(message.timestamp) }}</span>
              <span class="message-status" *ngIf="isUserMessage(message)">{{ getMessageStatusIcon(message) }}</span>
            </div>
          </div>
        </div>

        <!-- Indicador de escritura -->
        <div class="typing-indicator" *ngIf="typingIndicator" [@messageSlide]>
          <div class="message-avatar ai-avatar">
            <img 
              src="assets/img/logo/logo_ia.png" 
              alt="ClaudIA Assistant"
              (error)="onImageError($event)"
              loading="lazy" />
          </div>
          <div class="typing-content">
            <div class="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="chat-input" *ngIf="!isMinimized">
      <div class="input-container">
        <input 
          #messageInput
          type="text" 
          placeholder="Escribe tu mensaje..." 
          class="message-input"
          [(ngModel)]="currentMessage"
          (keyup)="onMessageInputKeyup($event)"
          [disabled]="!isConnected"
        />
        <button 
          class="send-btn" 
          (click)="onSendMessage()" 
          title="Enviar"
          [disabled]="!currentMessage.trim() || !isConnected">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Burbuja de Chat -->
  <div class="chat-bubble" 
     (click)="!isDragging && toggleChat()" 
     (mousedown)="onMouseDown($event)"
     [@bubblePulse]="bubbleState"
     [class.chat-open]="isChatOpen">

    
    <!-- Contador de mensajes no leídos -->
    <div class="unread-badge" *ngIf="unreadCount > 0 && !isChatOpen">
      {{ unreadCount > 99 ? '99+' : unreadCount }}
    </div>

    <!-- Ícono del chat -->
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="chat-icon">
      <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/>
    </svg>

    <!-- Ícono de cerrar cuando está abierto -->
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="close-icon" *ngIf="isChatOpen">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
  </div>
</div>